export const OBJECT_DISPLAY_STATE_INITIAL = 'OBJECT_DISPLAY_STATE_INITIAL';
export const OBJECT_DISPLAY_STATE_FEEDBACK = 'OBJECT_DISPLAY_STATE_FEEDBACK';
export const OBJECT_DISPLAY_STATE_RETRY = 'OBJECT_DISPLAY_STATE_RETRY';
export const OBJECT_DISPLAY_STATE_ANSWERED = 'OBJECT_DISPLAY_STATE_ANSWERED';
export const OBJECT_DISPLAY_STATE_REVIEW = 'OBJECT_DISPLAY_STATE_REVIEW';

export const OBJECT_PROGRESSION_CONTINUE = 'continue';
export const OBJECT_PROGRESSION_TRY_AGAIN = 'try_again';
export const OBJECT_PROGRESSION_TERMINAL = 'terminal';
export const OBJECT_PROGRESSION_GO_TO = 'go_to';
export const OBJECT_PROGRESSION_LINEAR = 'linear';
export const OBJECT_PROGRESSION_OPEN = 'open';
export const OBJECT_PROGRESSION_AUTO = 'auto';
export const OBJECT_PROGRESSION_END = 'end';


export const GO_TO_TYPE_OBJECT = 'object';
export const GO_TO_TYPE_SCREEN = 'screen';

export const TERMINAL_TYPE_SCREEN = 'end_screen';
export const TERMINAL_TYPE_BITE = 'end_bite';

export const SCREEN_RULE_TYPE_OPTIONAL = 'optional';
export const SCREEN_RULE_TYPE_REQUIRED = 'required';
export const SCREEN_RULE_TYPE_HIDDEN = 'hidden';
export const SCREEN_RULE_TYPE_TARGET = 'target';

export const STATUS_NOT_STARTED = 'NS';
export const STATUS_NOT_REQUIRED = 'NR';
export const STATUS_IN_PROGRESS = 'IP';
export const STATUS_COMPLETE = 'C';
export const STATUS_ATTEMPTED = 'A';
export const STATUS_SAVED = 'S';


export const CLASS_ACTIVE = 'active';
export const CLASS_NOT_STARTED = 'not-started';
export const CLASS_NOT_REQUIRED = 'not-required';
export const CLASS_IN_PROGRESS = 'in-progress';
export const CLASS_COMPLETE = 'complete';

export const RESULT_BEST = 'best';
export const RESULT_OK = 'ok';
export const RESULT_POOR = 'poor';
export const RESULT_REFLECTIVE = 'reflective';

export const STATUS_PASSED = 'P';
export const STATUS_FAILED = 'F';

export const OBJECT_COLUMN_LEFT = "left";
export const OBJECT_COLUMN_RIGHT = "right";

export const PARENT_SCREEN_TYPE_BITE_SCREEN = "screen";
export const PARENT_SCREEN_TYPE_TOOLBOX = "toolbox";
export const PARENT_SCREEN_TYPE_OBJECT = "object";

export const LINK_TYPE_TOOLBOX_SCREEN = "toolbox_screen";
export const LINK_TYPE_TOOLBOX_OBJECT = "toolbox_object";


export const PROGRESSION_TYPE_OPEN =  "open";
export const PROGRESSION_TYPE_LINEAR = "linear";
export const PROGRESSION_TYPE_EXPLORE_INTERESTS = "explore_options";

export const OBJECT_DISPLAY_STATES =[
    OBJECT_DISPLAY_STATE_INITIAL,
    OBJECT_DISPLAY_STATE_FEEDBACK,
    OBJECT_DISPLAY_STATE_RETRY,
    OBJECT_DISPLAY_STATE_REVIEW
];

export const YOU_TUBE_PRE_URL = "https://www.youtube.com/embed/";


export const PROMPT_TYPE_SHOW_PROMPT = "show_prompt";
export const PROMPT_TYPE_SHOW_UNTIL_ANSWERED = "show_until_answered";
export const PROMPT_TYPE_SHOW_NO_PROMPT = "no_prompt";
export const PROMPT_TYPE_DIALOG_PROMPT = "dialog_prompt";
export const DIALOG = "dialog";

export const ATTEMPT_TYPE_FIRST = "first";
export const ATTEMPT_TYPE_LAST = "last";

export const SCORING_TYPE_ASSESSED = "assessed";
export const SCORING_TYPE_FORMATIVE = "formative";
export const SCORING_TYPE_REFLECTIVE = "reflective";

export const FEEDBACK_TYPE_GIVE_FEEDBACK_IMMEDIATELY = "give_feedback_immediately";
export const FEEDBACK_TYPE_GIVE_FEED_LATER = "give_feedback_later";
export const FEEDBACK_TYPE_NO_FEEDBACK = "no_feedback";
export const FEEDBACK_TYPE_INCLUDE = "include_feedback";

export const SELECTION_TYPE_SELECT_ONE = "select_one";
export const SELECTION_TYPE_SELECT_MANY = "select_many";

export const RESULT_TYPE_BEST =  "best";
export const RESULT_TYPE_OK =  "ok";
export const RESULT_TYPE_POOR =  "poor";

export const INHERIT =  "inherit";

export const VIDEO_SUB_TYPE_VIMEO = 'vimeo';
export const VIDEO_SUB_TYPE_YOUTUBE = 'youtube';
export const VIDEO_SUB_TYPE_MP4 = 'mp4';

export const RESULT_DISPLAY_METHOD_SCORE_ONLY = "score_only";
export const RESULT_DISPLAY_METHOD_OBJECTIVES_ONLY = "objectives_only";
export const RESULT_DISPLAY_METHOD_SCORE_AND_OBJECTIVES = "score_and_objectives";

export const END_ACTION_REVIEW_OR_CLEAR = "review_or_clear_and_start_again";
export const END_ACTION_REVIEW = "review";
export const END_ACTION_RETURN_TO_MENU = "return_to_menu";
export const END_ACTION_CLEAR = "clear_and_start_again";
export const END_ACTION_EXIT = "exit_module";
export const END_ACTION_NONE = "none";

export const REQUIRED = "required";
export const OPTIONAL = "optional";
export const LINEAR = "linear";
export const CUSTOM = "custom";


export const TYPE_MENU = 'menu';
export const TYPE_SCREEN = 'screen';
export const TYPE_RESOURCE = 'resource';

export const DISPLAY_ALL_BADGES = "display_all_achievements";
export const DISPLAY_BITE_BADGES = "display_bite_achievements";

export const LABEL_TYPE_LEFT = "left";
export const LABEL_TYPE_RIGHT = "right";
export const LABEL_TYPE_NONE = "none";

export const DISPLAY_TYPE_INTRODUCTION = "introduction";
export const DISPLAY_TYPE_HOTSPOT = "hotspot";
export const DISPLAY_TYPE_CONCLUSION = "conclusion";

export const RESPOND_TYPE_INLINE = "respond_inline";
export const RESPOND_TYPE_ELSEWHERE = "respond_elsewhere";
export const RESPOND_TYPE_ELSEWHERE_IF_SCORM = "elsewhere_if_SCORM_1_2";

export const ASSESSED_TYPE_NONE = "not_assessed";
export const ASSESSED_TYPE_FORMATIVE = "self_assessed_formative";
export const ASSESSED_TYPE_SCORED = "self_assessed_scored";

export const ACHIEVED = "achieved";
export const NOT_ACHIEVED = "not_achieved";

export const AND = "and";
export const OR = "or";

export const LARGE_BACKGROUND = "large_background";
export const MOBILE_BACKGROUND = "mobile_background";


export const BADGE_TYPE_SHIELD = "shield";
export const BADGE_TYPE_IMAGE = "image";

export const TAB_TYPE_HORIZONTAL = "horizontal";
export const TAB_TYPE_VERTICAL = "vertical";
export const TAB_TYPE_HORIZONTAL_FRAMELESS = "horizontal_frameless";
export const TAB_TYPE_VERTICAL_FRAMELESS = "vertical_frameless";
export const TAB_TYPE_HORIZONTAL_PROCESS = "horizontal_process";
export const TAB_TYPE_VERTICAL_PROCESS = "vertical_process";
export const TAB_TYPE_HORIZONTAL_TILE = "horizontal_tile";
export const TAB_TYPE_VERTICAL_TILE = "vertical_tile";

export const SLIDER_TYPE_HORIZONTAL = "horizontal";
export const SLIDER_TYPE_HORIZONTAL_TIMELINE = "horizontal_timeline";


export const PANEL_LOCATION_LEFT = "left";
export const PANEL_LOCATION_RIGHT = "right";
export const PANEL_LOCATION_CENTERED = "centered";

export const PRINT_FROM_THIS_BITE = "this_bite";
export const PRINT_FROM_ALL_BITES = "all_bites";
export const INCLUDE_IN_PRINT = "include_in_print";
export const EXCLUDE_FROM_PRINT = "exclude_in_print";
export const HOTSPOT_DISPLAY_TYPES = [
    DISPLAY_TYPE_INTRODUCTION,
    DISPLAY_TYPE_HOTSPOT,
    DISPLAY_TYPE_CONCLUSION
];


//object animations duration


export const PROGRESS_UPDATE_DURATION = 1;
export const DIALOG_DURATION = 0.5;
export const FEEDBACK_DURATION = 0.3;
export const OPTION_FEEDBACK_DURATION = 0.2;
export const SPEECH_BUBBLE_DURATION = 0.3;
export const HIDE_SPEECH_BUBBLE_DURATION = 0.3;
export const BUTTON_DURATION = 0.2;
export const ACCORDION_BUTTON_DURATION = 0.2;
export const DROPDOWN_MENU_OPEN_DURATION = 0.3;
export const DROPDOWN_MENU_CLOSE_DURATION = 0.3;
export const SHOW_PANEL_DURATION = 0.3;
export const MC_OPTION_DURATION = 0;
export const QUESTION_DURATION = 0.7;
export const SCROLL_TO_DURATION = 0.5;
//export const MC_OPTION_DURATION = 0.5;
export const SHOW_BADGE_PANEL_DURATION = 1.5;

export const KPI_ROTATION_DURATION = 0.7;

export const SCROLL_TO = 250;
export const SCROLL_SPEED = 0.5;
export const NAV_SPEED = 0.7;


export const ASSET_LEFT_PANEL_POSTFIX = "_assetLeftPanelImage";
export const ASSET_RIGHT_PANEL_POSTFIX = "_assetRightPanelImage";
export const ASSET_LEFT_POSTFIX = "_assetLeftImage";
export const ASSET_RIGHT_POSTFIX = "_assetRightImage";
export const CONTENT_AREA_POSTFIX = "_contentArea";

export const IMAGE_SIZE_ACTUAL = "actual";
export const IMAGE_SIZE_RETINA = "retina";
export const IMAGE_SIZE_SPECIFIC = "specific";
export const IMAGE_SIZE_MAX = "max";

export const IMAGE_SHAPE_NONE = "none";
export const IMAGE_SHAPE_SQUARE = "square";
export const IMAGE_SHAPE_CIRCLE = "circle";
export const IMAGE_SHAPE_RECTANGLE = "rectangle";

export const IMAGE_WIDTH_5 = "image_width_5";
export const IMAGE_WIDTH_10 = "image_width_10";
export const IMAGE_WIDTH_15 = "image_width_15";
export const IMAGE_WIDTH_20 = "image_width_20";
export const IMAGE_WIDTH_25 = "image_width_25";
export const IMAGE_WIDTH_30 = "image_width_30";
export const IMAGE_WIDTH_35 = "image_width_35";
export const IMAGE_WIDTH_40 = "image_width_40";

export const ASSET_IMAGE_WIDTH_10 = "asset_image_width_10";
export const ASSET_IMAGE_WIDTH_15 = "asset_image_width_15";
export const ASSET_IMAGE_WIDTH_20 = "asset_image_width_20";
export const ASSET_IMAGE_WIDTH_25 = "asset_image_width_25";
export const ASSET_IMAGE_WIDTH_30 = "asset_image_width_30";
export const ASSET_IMAGE_WIDTH_35 = "asset_image_width_35";
export const ASSET_IMAGE_WIDTH_40 = "asset_image_width_40";

export const TOP_ASSET_IMAGE_WIDTH_10 = "asset_image_width_10";
export const TOP_ASSET_IMAGE_WIDTH_20 = "asset_image_width_20";
export const TOP_ASSET_IMAGE_WIDTH_30 = "asset_image_width_30";
export const TOP_ASSET_IMAGE_WIDTH_40 = "asset_image_width_40";
export const TOP_ASSET_IMAGE_WIDTH_50 = "asset_image_width_50";
export const TOP_ASSET_IMAGE_WIDTH_60 = "asset_image_width_60";
export const TOP_ASSET_IMAGE_WIDTH_70 = "asset_image_width_70";
export const TOP_ASSET_IMAGE_WIDTH_80 = "asset_image_width_80";
export const TOP_ASSET_IMAGE_WIDTH_90 = "asset_image_width_90";
export const TOP_ASSET_IMAGE_WIDTH_100 = "asset_image_width_100";

export const KPI_DISPLAY_SCOPE_BOTH = "both";
export const KPI_DISPLAY_SCOPE_PRIMARY = "primary";
export const KPI_DISPLAY_SCOPE_SECONDARY = "secondary";

export const HOT_SPOT_TYPE_NO_SCREEN = "no_screen";
export const HOT_SPOT_TYPE_LARGE_SCREEN = "large_screen";
export const HOT_SPOT_TYPE_MOBILE_SCREEN = "mobile_screen";
export const HOT_SPOT_TYPE_FULL_SCREEN = "full_screen";

export const HOT_SPOT_BUTTON_TYPE_CHECK_ROLLOVER = "check_rollover";
export const HOT_SPOT_BUTTON_TYPE_CHECK_OPEN_TOOLTIP = "check_open_tooltip";
export const HOT_SPOT_BUTTON_TYPE_CHECK_LABEL = "check_label";
export const HOT_SPOT_BUTTON_TYPE_SMALL_ICON = "small_icon";
export const HOT_SPOT_BUTTON_TYPE_SMALL_ICON_LABEL = "small_icon_label";
export const HOT_SPOT_BUTTON_TYPE_LARGE_ICON = "large_icon";
export const HOT_SPOT_BUTTON_TYPE_LARGE_ICON_LABEL = "large_icon_label";


export const PREVIEW_DISPLAY_TYPE_CONTENT_ONLY = "content_only";
export const PREVIEW_DISPLAY_TYPE_CONTENT_AND_OUTLINE = "content_and_outline";
export const PREVIEW_DISPLAY_TYPE_OUTLINE_ONLY = "outline_only";


export const PROTOTYPE_CHARACTER_SPEAK_TEXT = "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In congue est in eros venenatis cursus.</p>";
export const PROTOTYPE_LEARNER_SPEAK_TEXT = "<p>Phasellus fringilla metus.</p>";
export const PROTOTYPE_CHARACTER_CHOICE_PROMPT_TEXT = "<p>Fusce suscipit magna quis turpis venenatis?</p>";
export const PROTOTYPE_CHARACTER_CHOICE_RESPONSE_TEXT = "<p>Vestibulum vitae tellus imperdiet.</p>";

export const PROTOTYPE_TEXT_TITLE = "<p>Lorem ipsum dolor sit amet</p>";
export const PROTOTYPE_TEXT = "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In congue est in eros venenatis cursus. Nullam semper eros in ipsum facilisis sodales. Phasellus condimentum lobortis nisl et cursus.</p>";


export const PROTOTYPE_DOCUMENT_TITLE = "Lorem ipsum dolor sit amet";
export const PROTOTYPE_DOCUMENT_TEXT = "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In congue est in eros venenatis cursus. Nullam semper eros in ipsum facilisis sodales. Phasellus condimentum lobortis nisl et cursus.</p>";

export const PROTOTYPE_LINK_TITLE = "Lorem ipsum";
export const PROTOTYPE_LINK_SUB_TITLE = "http://www.lorem-ipsum.org";
export const PROTOTYPE_LINK_TEXT = "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In congue est in eros venenatis cursus.</p>";

export const SCROLL_LAYOUT_TYPE_FULL_HEIGHT = "full_height";
export const SCROLL_LAYOUT_TYPE_FRAMED = "framed";

export const  DEFAULT_HEADING_CLASS = "heading_4";

export const HOT_SPOT_LARGE_SCREEN_MAX_WIDTH = 1024;
export const HOT_SPOT_NO_SCREEN_MAX_WIDTH = 1024;
export const HOT_SPOT_FULL_SCREEN_MAX_WIDTH = 1200;
export const HOT_SPOT_MOBILE_SCREEN_MAX_WIDTH = 420;

export const YOU = "you";

export const LEARNER_NAME_DISPLAY_TYPE_CUSTOM = "custom";
export const LEARNER_NAME_DISPLAY_TYPE_INHERIT = "inherit";

export const THEME_PRIMARY_COLOR = "primary_color";
export const THEME_SECONDARY_COLOR = "secondary_color";
export const THEME_MONOCHROME_COLOR = "monochrome_color";
export const DARK_GREY_COLOR = "#333333";

export const ORIENTATION_LANDSCAPE = "landscape";
export const ORIENTATION_PORTRAIT = "portrait";



/** WEBPACK FOOTER **
 ** ./src/constants/objectConstants.js
 **/